import { useMemo, useRef } from 'react';

import { DateTime, Interval } from 'luxon';

import { adminWorkshiftDetails, ILongContractAttributes, pharmacyWorkshift } from '@pharmaplan/common';
import { mergeContractAttributes } from '@pharmaplan/common/helpers/utils';

import { appendTimeToDate } from '../../helpers/workshift/functions';
import { useAppSelector } from '../useAppSelector';
import { toStandardFormat } from '../../helpers/Functions';
import useAdmin from '../useAdmin';

interface IUseGenerateContractRange {
  startDate: DateTime;
  endDate: DateTime;
  startTime: string | Date;
  endTime: string | Date;
  isUpdate?: boolean;
}

const useGenerateContractRange = () => {
  const currentWorkshift = useAppSelector(pharmacyWorkshift);
  const adminWorkshift = useAppSelector(adminWorkshiftDetails);

  const { isAdmin } = useAdmin();

  const { shiftContractAttributes = [], bookedShifts = [] } = isAdmin ? adminWorkshift : currentWorkshift ?? {};
  const commonParams = useRef<IUseGenerateContractRange>({
    startDate: DateTime.now(),
    endDate: DateTime.now(),
    startTime: '',
    endTime: '',
  });

  const generate = () => {
    let interval: ILongContractAttributes[] = [];

    const startFormat = commonParams.current.startDate;
    const endFormat = commonParams.current.endDate;

    interval = Interval.fromDateTimes(startFormat, endFormat)
      .splitBy({ day: 1 })
      .map((item) =>
        ({
          startDate: toStandardFormat(item.start?.set({ hour: 9 })),
          endDate: toStandardFormat(item.start?.set({ hour: 17 })),
          dayOff: false,
        }));

    console.log(startFormat.toISO(), endFormat.toISO());
    interval.map((item) =>
      console.log(item.startDate));

    return interval;
  };

  const generateUpdate = () => {
    let interval: ILongContractAttributes[] = [];

    const startFormat = appendTimeToDate(
      commonParams.current.startDate.toISO({ includeOffset: false }) ?? '',
      commonParams.current.startTime,
    );
    const endFormat = appendTimeToDate(
      commonParams.current.endDate.toISO({ includeOffset: false }) ?? '',
      commonParams.current.endTime,
    );

    const { hour, minute, second } = endFormat ?? {};

    interval = Interval.fromDateTimes(startFormat, endFormat)
      .splitBy({ day: 1 })
      .map((item) =>
        ({
          startDate: toStandardFormat(item.start ?? DateTime.now()),
          endDate: toStandardFormat(item.start?.set({ hour, minute, second }) ?? DateTime.now()),
          dayOff: false,
        }));

    const bookedShiftsFormat = bookedShifts.map((item) =>
      ({ ...item, booked: true }));

    const merged = mergeContractAttributes(
      interval,
      [...shiftContractAttributes, ...bookedShiftsFormat],
    );
    return merged;
  };

  const compare = () => {
    const intervals = commonParams.current?.isUpdate
      ? generateUpdate()
      : generate();
    return intervals;
  };

  const getInitialShiftAttributes = (params: IUseGenerateContractRange) => {
    commonParams.current = params;
    const areValuesSelected = commonParams.current.startDate && commonParams.current.endDate;
    if (areValuesSelected) {
      return compare();
    }
    return [];
  };

  return { getInitialShiftAttributes };
};

export default useGenerateContractRange;
